import * as t from './actionTypes';
import { FetchViewsResponseAction } from './types';

const initialState = {
  views: [],
  metadata: {},
  viewsLoading: false,
};

const savedViewsIndexReducer = (state = initialState, action: { type: string }) => {
  switch (action.type) {
    case t.FETCH_VIEWS_REQUEST:
      return {
        ...state,
        viewsLoading: true,
      };
    case t.FETCH_VIEWS_RESPONSE:
      return {
        ...state,
        viewsLoading: false,
        views: (action as FetchViewsResponseAction).views,
        metadata: (action as FetchViewsResponseAction).metadata,
      };
    case t.FETCH_VIEWS_ERROR:
      return {
        ...state,
        viewsLoading: false,
      };
    default: {
      return state;
    }
  }
};

export default savedViewsIndexReducer;
